// extracted by mini-css-extract-plugin
export default {"sideBar":"index_sideBar_GItNV","h2wrapper":"index_h2wrapper_wtdV5"};